var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "fast-wizard" } }, [
    _c(
      "div",
      { staticClass: "steps" },
      [
        _c(
          "a-steps",
          {
            style: _vm.stepStyle,
            attrs: { type: "navigation" },
            model: {
              value: _vm.current,
              callback: function ($$v) {
                _vm.current = $$v
              },
              expression: "current",
            },
          },
          [
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(0),
                title: _vm.$t("fastWizard.moreInfo"),
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(1),
                title: _vm.$t("fastWizard.display"),
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(2),
                title: _vm.$t("fastWizard.availability"),
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(3),
                title: _vm.$t("fastWizard.preview"),
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                status: _vm.getStatus(4),
                title: _vm.$t("fastWizard.installCode"),
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === 0,
              expression: "current === 0",
            },
          ],
          staticClass: "step step0",
        },
        [_c("MoreDetail")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === 1,
              expression: "current === 1",
            },
          ],
          staticClass: "step step1",
        },
        [_c("DisplayConfig")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === 2,
              expression: "current === 2",
            },
          ],
          staticClass: "step step2",
        },
        [_c("AvailabilityConfig")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === 3,
              expression: "current === 3",
            },
          ],
          staticClass: "step step3",
        },
        [_c("Preview")],
        1
      ),
      _vm._v(" "),
      _vm.current === 4
        ? _c("div", { staticClass: "step step4" }, [_c("InstallCode")], 1)
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wizard-footer" }, [
      _c(
        "div",
        [
          _vm.current > 0
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary", ghost: "", size: "large" },
                  on: {
                    click: function ($event) {
                      _vm.current = _vm.current - 1
                    },
                  },
                },
                [
                  _c("a-icon", { attrs: { type: "left" } }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("fastWizard.previous")) +
                      "\n            "
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("h4", [_vm._v(_vm._s(_vm.$t("fastWizard.setupSupsisLiveChat")))]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.current < 4
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary", ghost: "", size: "large" },
                  on: {
                    click: function ($event) {
                      _vm.current = _vm.current + 1
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("fastWizard.continue")) +
                      "\n                "
                  ),
                  _c("a-icon", { attrs: { type: "right" } }),
                ],
                1
              )
            : _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    size: "large",
                    disabled: _vm.waiting,
                  },
                  on: { click: _vm.complete },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("fastWizard.completeInitialize")) +
                      "\n            "
                  ),
                ]
              ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }